export default {
  '004': '국민',
  '003': '기업',
  '011': '농협',
  '088': '신한',
  '081': '하나',
  '020': '우리',
  '002': '산업',
  '032': '부산',
  '031': '대구',
  '027': '씨티',
  '023': 'SC제일',
  '039': '경남',
  '034': '광주',
  '007': '수협',
  '037': '전북',
  '035': '제주',
  '045': '새마을금고',
  '071': '우체국',
  '048': '신협',
  '050': 'SBI저축',
  '064': '산림조합중앙회',
  '089': '케이뱅크',
  '090': '한국카카오',
}
